module.exports = __webpack_public_path__ + "static/media/ep-global-logo.6d1dd468.png";